export const getIsOpenTag = (index: number, indexesToRemove: number[]): boolean => {
  return (index - indexesToRemove.length) % 2 === 0;
};
